<ng-content></ng-content>
<a class="toggle-container" (click)="toggleShow()">
	<ion-icon iconMode class="show-option" [hidden]="showPassword" name="eye-off-outline"></ion-icon>
	<ion-icon iconMode class="hide-option" [hidden]="!showPassword" name="eye-outline"></ion-icon>
</a>
